import styled, { css } from 'styled-components';

type CardItemProps = {
  active: boolean;
  isSelected?: boolean;
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const CardItem = styled.div<CardItemProps>`
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: #f0f2ff;
      border-color: #0b29fb;
    `}

  ${({ active }) =>
    !active &&
    css`
      filter: opacity(0.5);
    `}
`;

export const Img = styled.img`
  width: 24px;
  height: 24px;
`;

export const Text = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #000;
`;
